

export enum ProjectType {
    Code,
    Music,
} 